import React from 'react'
import { Link } from 'react-router-dom'
import { t } from 'translation'
import { connect } from 'react-redux'

const PrescriberCodeStepOne = (props) => {
  return (
    <>
      <div className="tab_content_wrap auth_block">
        <h1 className="section_title v4_mod color_mod offset_v4_mod decor_mod center_mod">
          {t('signup.SIGNING_UP')}
        </h1>
        <div className="auth_block_descr decor_mod offset_mod center_lvl_mod">
          {t('signup.SIGNING_UP_DESCR')}
        </div>
        <div className="phone_system_buttons offset_mod">
          <button
            className="phone_system_buttons_item btn_download"
            onClick={() => {
              props.setPrescriberCode('SPTDEZIE')
              props.setSignupWithoutPrescriberCode(true)
              props.setPrescriberStep('two')
            }}
          >
            {t('signup.SIGNUP_BUTTON_2')}
          </button>
          <button
            className="phone_system_buttons_item btn_download"
            onClick={() => {
              props.setPrescriberCode('SWIGYKVN')
              props.setSignupWithoutPrescriberCode(true)
              props.setPrescriberStep('two')
            }}
          >
            {t('signup.SIGNUP_BUTTON_3')}
          </button>
          <button
            className="phone_system_buttons_item btn_download"
            onClick={() => {
              props.setPrescriberCode('MMXJUKVM')
              props.setSignupWithoutPrescriberCode(true)
              props.setPrescriberStep('two')
            }}
          >
            {t('signup.SIGNUP_BUTTON_4')}
          </button>
          <div className="text_with_line">
            <span>{t('signup.OR')}</span>
          </div>
          <button
            className="phone_system_buttons_item btn_download"
            onClick={() => props.setPrescriberStep('two')}
          >
            {t('signup.SIGNUP_BUTTON_1')}
          </button>
        </div>
        <div className="btn_wrap center_lvl_mod top_link">
          <span className="auth_block_member_link">
            {t('signup.ALREADY_MEMBER')}
            <Link to="/login">{t('signup.CONNECT')}</Link>
          </span>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = ({
  auth: { attributes, error, loading, isAuthenticated, isDoctor },
}) => {
  return {
    attributes,
    loading,
    isAuthenticated,
    isDoctor,
    authError: error,
  }
}

export default connect(mapStateToProps)(PrescriberCodeStepOne)
